import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',

    paddingBottom: theme.spacing(4.5),
    overflowX: 'hidden',

    '&::after': {
      display: 'block',
      left: 0,
      bottom: 0,
      content: '""',
      position: 'absolute',
      borderTop: '50px solid transparent',
      borderRight: `100vw solid #EEEEEE`,
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    color: theme.palette.common.white,

    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      marginTop: theme.spacing(4),
    },

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      textAlign: 'left',

      '& img': {
        marginTop: 0,
      },
    },
  },
  titleB2B: {
    fontSize: 34,
    fontWeight: 'bold',
    fontFamily: 'Arial',
  },
}));
